<template>
    <div class="bg-white p-4 shadow rounded-lg">
        <h2 class="text-lg font-semibold text-gray-700 mb-2 flex items-center">
            <span class="mr-2">🧭</span> Program Distribution
        </h2>
        <apexchart type="donut" height="300" :options="donutOptions" :series="donutSeries" />
    </div>
</template>

<script>
export default {
    name: "ProgramDistributionChart",
    props: {
        categoryCounts: {
            type: Object,
            required: true
        },
        powerBiColors: {
            type: Array,
            required: true
        }
    },
    computed: {
        donutOptions() {
            const labels = Object.keys(this.categoryCounts);
            const counts = Object.values(this.categoryCounts);

            // Create labels with counts
            const labelsWithCounts = labels.map((label, index) => `${label} (${counts[index]})`);

            return {
                labels: labelsWithCounts,
                legend: {
                    position: 'bottom',
                    fontSize: '12px',
                    fontWeight: 500
                },
                colors: this.powerBiColors.slice(0, Object.keys(this.categoryCounts).length),
                dataLabels: { enabled: true },
            };
        },
        donutSeries() {
            return Object.values(this.categoryCounts);
        }
    }
};
</script>

<style lang="scss" scoped></style>
